// extracted by mini-css-extract-plugin
export default {"fullWidth":"CommonSelectField_fullWidth__yvCcg"};